export default "__VITE_ASSET__CCDb2YTc__"